/* eslint @okta/okta/no-specific-modules: 0 */
import Handlebars from 'handlebars';
import _ from '../underscore-wrapper';
const CACHE_BUST_URL_PREFIX = '/assets';

function prependCachebustPrefix(path) {
  if (path.indexOf(CACHE_BUST_URL_PREFIX) === 0) {
    return path;
  }
  return CACHE_BUST_URL_PREFIX + path;
}

Handlebars.registerHelper('img', function (options) {
  const cdn = (typeof okta !== 'undefined' && okta.cdnUrlHostname) || '';
  /*global okta */

  const hash = _.pick(options.hash, ['src', 'alt', 'width', 'height', 'class', 'title']);

  hash.src = '' + cdn + prependCachebustPrefix(hash.src);

  const attrs = _.map(hash, function (value, attr) {
    return attr + '="' + (attr === 'src' ? encodeURI(value) : Handlebars.Utils.escapeExpression(value)) + '"';
  });

  return new Handlebars.SafeString('<img ' + attrs.join(' ') + '/>');
});

export default Handlebars;



// WEBPACK FOOTER //
// /Users/aarongranick/okta/okta-ui/packages/courage/src/util/handlebars/helper-img.js


// WEBPACK FOOTER //
// webpack:///Users/aarongranick/okta/okta-ui/packages/courage/src/util/handlebars/helper-img.js